import { STATIC_ASSETS_URL } from "common/context/constants"

const DirectAccessCard = ({ withCornerFolded, content }: $TSMigrationFixMe) => {
  return (
    <div
      className={`${
        withCornerFolded
          ? "direct-access-card-with-corner-folded"
          : "direct-access-card"
      } d-flex flex-column justify-content-around`}
    >
      {withCornerFolded && (
        <>
          <div className='d-flex flex-column justify-content-around'>
            <div className='direct-access-empty-line-1' />
            <div className='direct-access-empty-line-2' />
          </div>
          <div className='direct-access-corner-folded' />
        </>
      )}
      <div className={`item-new ${withCornerFolded ? "" : "mt-4"}`}>
        <div className='direct-access-icon d-flex items-center justify-content-center mb-5'>
          <img
            src={`${STATIC_ASSETS_URL}/Imagenes/Ilustraciones/${content?.nameIcon}`}
            alt={content?.nameIcon}
            className='iconsDirectAccess'
          />
        </div>

        <div className='text-black d-flex items-center justify-content-center mt-2'>
          {content?.text}
        </div>
      </div>
    </div>
  )
}

export default DirectAccessCard
